import classNames from 'classnames';
import {twMerge} from 'tailwind-merge';

export const styleTool = {
	responsiveSize(initialSize: number) {
		return (initialSize * window.innerWidth) / 1440;
	},
};

export const cn = (...args: any[]) => twMerge(classNames(...args));
